import {useState} from 'react'
import {ProductVoucher, createProductVoucher, editProductVoucher} from './api'
import {useLayout} from '../../../../_metronic/layout/core'
import {KTIcon, OptionType} from '../../../../_metronic/helpers'
import toast from 'react-hot-toast'
import Select from 'react-select'

const validateVoucherName = (value: string) => {
  const regex = /^(?!.*\bnone\b)[a-zA-Z0-9-' ]{1,25}$/
  return regex.test(value)
}

const voucherTypes = [
  {
    value: '',
    label: 'Select a Voucher Type...',
  },
  {
    label: 'Sales',
    value: 'Sales',
  },
  {
    label: 'Purchase',
    value: 'Purchase',
  },
  {
    label: 'Receipt',
    value: 'Receipt',
  },
  {
    label: 'Payment',
    value: 'Payment',
  },
  {
    label: 'Journal',
    value: 'Journal',
  },
  {
    label: 'Contra',
    value: 'Contra',
  },
  {
    label: 'Credit Note',
    value: 'Credit Note',
  },
  {
    label: 'Debit Note',
    value: 'Debit Note',
  },
]
export const CreateEditVoucher: React.FC<{
  setCreateVoucher: React.Dispatch<React.SetStateAction<boolean>>
  editVoucher?: ProductVoucher
  setShouldRefreshVouchers: React.Dispatch<React.SetStateAction<boolean>>
}> = ({setCreateVoucher, editVoucher, setShouldRefreshVouchers}) => {
  const {company} = useLayout()
  const [loading, setLoading] = useState(false)
  const [voucherType, setVoucherType] = useState(
    editVoucher?.voucherType
      ? {
          value: editVoucher.voucherType,
          label: editVoucher.voucherType,
        }
      : {
          value: '',
          label: 'Select a Voucher Type...',
        }
  )
  const [voucherName, setVoucherName] = useState(editVoucher ? editVoucher.voucherName : '')
  const [voucherNameError, setVoucherNameError] = useState<string>('')

  const validateAndSetVoucherName = (value: string) => {
    setVoucherName(value)

    if (!value) {
      setVoucherNameError('Voucher name is required')
    } else if (!validateVoucherName(value)) {
      if (value.length > 25) {
        setVoucherNameError('Voucher name cannot exceed 25 characters')
      } else if (value.toLowerCase().includes('none')) {
        setVoucherNameError('Voucher name cannot contain the word "none"')
      } else {
        setVoucherNameError(
          'Voucher name can only contain letters, numbers, hyphens, apostrophes and spaces'
        )
      }
    } else {
      setVoucherNameError('')
    }
  }
  const handleCreateNewGroup = async () => {
    // Validate before submission
    if (!validateVoucherName(voucherName)) {
      return
    }
    setLoading(true)
    if (!editVoucher?.voucherId)
      createProductVoucher({
        // voucher_id: editVoucher?.voucherId,
        company_id: Number(company?.value),
        voucher_type: voucherType.value,
        voucher_name: voucherName,
      })
        .then((res) => {
          res?.detail && toast.success(res.detail)
          setVoucherType({
            value: '',
            label: 'Select a Voucher Type...',
          })
          setVoucherName('')

          setShouldRefreshVouchers(true)
        })
        .catch((err) => err && toast.error(err))
        .finally(() => {
          setLoading(false)
          setCreateVoucher(false)
        })
    else
      editProductVoucher({
        voucher_id: editVoucher?.voucherId,
        company_id: Number(company?.value),
        voucher_type: voucherType.value,
        voucher_name: voucherName,
        is_editable: true,
      })
        .then((res) => {
          res?.detail && toast.success(res.detail)
          setVoucherType({
            value: '',
            label: 'Select a Voucher Type...',
          })
          setVoucherName('')

          setShouldRefreshVouchers(true)
        })
        .catch((err) => err && toast.error(err))
        .finally(() => {
          setLoading(false)
          setCreateVoucher(false)
        })
  }

  return (
    <div className='card'>
      <div
        className='card-header border-0'
        data-bs-target='#kt_account_profile_details'
        aria-expanded='true'
        aria-controls='kt_account_profile_details'
      >
        <div className='card-title m-0'>
          <h3 className='fw-bolder m-0'>
            {!!editVoucher ? 'Update Voucher Type' : 'Add New Voucher Type'}
          </h3>
        </div>
      </div>

      <div id='kt_account_profile_details' className='collapse show'>
        <div className='card-body border-top p-9'>
          <div className='row mb-6'>
            <label className='col-lg-4 col-form-label fw-bold fs-6'>
              <span className='required'>Inbuilt Voucher Type</span>
            </label>

            <div className='col-lg-8 fv-row'>
              <Select
                // {...formik.getFieldProps('reportingCurrency')}
                value={voucherType}
                onChange={(option: any) => setVoucherType(option as OptionType)}
                options={voucherTypes}
                isSearchable={true}
                className={'fw-bold'}
                styles={{
                  control: (baseStyles: any, state: any) => ({
                    ...baseStyles,
                    // marginLeft: '2px',
                    backgroundColor: 'var(--bs-gray-100)',
                    borderColor: 'var(--bs-gray-100)',
                    color: 'var(--bs-gray-700)',
                    fontWeight: 500,
                  }),
                }}
                components={{IndicatorSeparator: () => null}}
              />
              {/* <select
                className='form-select form-select-solid form-select-lg fw-bold'
                value={voucherType}
                onChange={(e) => setVoucherType(e.currentTarget.value)}
              >
                <option value=''>Select a Voucher Type...</option>
                <option value='Sales'>Sales</option>
                <option value='Purchase'>Purchase</option>
                <option value='Receipt'>Receipt</option>
                <option value='Payment'>Payment</option>
                <option value='Journal'>Journal</option>
                <option value='Contra'>Contra</option>
                <option value='Credit Note'>Credit Note</option>
                <option value='Debit Note'>Debit Note</option>
              </select> */}
            </div>
          </div>

          <div className='row mb-6'>
            <label className='col-lg-4 col-form-label required fw-bold fs-6'>Voucher Name</label>

            <div className='col-lg-8 fv-row'>
              <input
                type='text'
                className={`form-control form-control-lg form-control-solid ${
                  voucherNameError ? 'is-invalid' : ''
                }`}
                placeholder='Voucher name'
                value={voucherName}
                onChange={(e) => validateAndSetVoucherName(e.target.value)}
              />
              {voucherNameError && (
                <div className='invalid-feedback d-block'>{voucherNameError}</div>
              )}
            </div>
          </div>
        </div>

        <div className='card-footer d-flex justify-content-end py-6 px-9'>
          <button
            className='btn btn-secondary'
            style={{marginRight: '10px'}}
            onClick={() => {
              setCreateVoucher(false)
              setShouldRefreshVouchers(false)
            }}
          >
            Cancel
          </button>
          <button
            onClick={handleCreateNewGroup}
            className='btn btn-primary ml-2'
            disabled={loading || !voucherName.length || !voucherType.value || !!voucherNameError}
          >
            {!loading && !!editVoucher ? 'Update Voucher Type' : 'Add Voucher Type'}
            {loading && (
              <span className='indicator-progress' style={{display: 'block'}}>
                Please wait...{' '}
                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
              </span>
            )}
          </button>
        </div>
      </div>
    </div>
  )
}
